import './SearchFormBanner.scss';
import { getString } from '../../helpers/styles';
import { submitSearchForm } from '../../helpers/form';
import Search from '../../shared/assets/icons/search.svg';

export default function SearchFormBanner(props) {
  if (!props.organizations) props.organizations = [];

  const defaultSearch = props.type !== 'obstetricianPractices';

  const [label, placeholder] = defaultSearch
    ? [
        'Zoek je iets specifieks? Gebruik de zoekmachine!',
        'Categorie, tag, onderwerp...'
      ]
    : ['Zoek een zorgverlener bij jou in de buurt!', 'Postcode'];

  return (
    <section
      id="searchFormBanner"
      className={getString('searchFormBanner_default_view', defaultSearch)}
    >
      <form onSubmit={(e) => search(e)}>
        <label htmlFor="search">{label}</label>

        <input
          type="text"
          name="search"
          autoComplete="off"
          placeholder={placeholder}
          id="searchFormBanner_input"
          {...(!defaultSearch && { maxLength: '4' })}
        />

        <span onClick={(e) => search(e)} id="searchFormBanner_input_icon">
          <Search />
        </span>
      </form>

      {!!props.organizations.length && (
        <ul id="searchFormBanner_results">
          {props.organizations.map((item, idx) => (
            <li key={idx}>
              <a
                href={
                  item.primaryChannel?.uri
                    ? `/channels/${item.primaryChannel.uri}`
                    : item.website
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="searchFormBanner_results_image">
                  <img alt="provider-image" src={item.logoUrl} />
                </div>

                <div>
                  <p>{item.displayName}</p>
                  <span>{item.distance} kilometer</span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );

  function search(e) {
    if (defaultSearch) return submitSearchForm(e);

    e.preventDefault();

    const value = document
      .getElementById('searchFormBanner_input')
      .value.trim();

    if (!value) return;

    props.getOrganizations({
      variables: {
        distance: 1000,
        postalcode: value
      }
    });
  }
}
